var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.docsPath && _vm.hasDocsFile)?_c('a',{staticClass:"helper-control",on:{"click":_vm.openDocsPreviwModal}},[_c('b-icon',{attrs:{"icon":"question-circle"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }